import React from 'react';
import { Typography } from '@mui/material';
import type { ParagraphBlock } from '../../../types/backend';

interface Props {
  block: ParagraphBlock;
}

const ParagraphBlockView: React.FC<Props> = ({ block }) => (
  <Typography
    variant="body2"
    sx={{ my: 1, color: 'text.primary', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}
  >
    {block.text}
  </Typography>
);

export default ParagraphBlockView;
